import { provideConfig } from '@spartacus/core'
import { NgModule } from '@angular/core'
import { FsComponentConverter } from 'fs-spartacus-common'
import { FULL_WIDTH_ORDER_BOX_CONVERTER_TOKEN, FullWidthOrderBoxConverter } from './full-width-order-box.component.converter'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        fullWidthOrderBoxFeature: {
          module: () => import('./full-width-order-box.module').then((m) => m.FullWidthOrderBoxModule),
          cmsComponents: ['full_width_order_box'],
        },
      }
    }),
    {
      provide: FULL_WIDTH_ORDER_BOX_CONVERTER_TOKEN,
      useExisting: FullWidthOrderBoxConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        full_width_order_box: FULL_WIDTH_ORDER_BOX_CONVERTER_TOKEN
      },
      multi: true
    }
  ]
})
export class FullWidthOrderBoxFeatureModule {}
